import { useState, type InputHTMLAttributes } from 'react';
import { EyeRegular, EyeOffRegular } from '@fluentui/react-icons';
export function PasswordInput(props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [visible, setVisible] = useState(false);
  return <span className="password-input-control"><input {...props} type={visible ? 'text' : 'password'} /><button type="button" aria-label={visible ? '隐藏密码' : '显示密码'} aria-pressed={visible} onMouseDown={event=>event.preventDefault()} onClick={()=>setVisible(value=>!value)}>{visible ? <EyeOffRegular /> : <EyeRegular />}</button></span>;
}
